// reducer
// import Vue from "vue";

export const nutritionist = (state, data) => {
  state.Nutritionist.nutritionist = data;
};
